import React, { ReactNode } from 'react';
import { SgwtHelpCenter } from '@sgwt/sgwt-widgets-react';

declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      'sg-error-page': {
        code: 404 | 500 | 503;
        theme?: 'dark' | 'standard';
        'action-button-label'?: string;
        'action-button-link'?: string;
        'contact-us'?: 'help-center' | string;
        fullscreen?: boolean;
        'description-label'?: string;
        'title-label'?: string;
      };
    }
  }
}

interface IErrorBoundaryState {
  error: Error | null;
}

interface IErrorBoundaryProps {
  children: ReactNode;
}

export class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  public state: IErrorBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  public componentDidCatch(errorDetected: Error, errorInfo: React.ErrorInfo) {
    console.error(
      `ErrorBoundary error[${errorDetected.message}] stack[${errorDetected.stack}] errorInfo[${errorInfo}]`
    );
  }

  public render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <div style={{ height: '100vh' }}>
          <SgwtHelpCenter applicationId={import.meta.env.VITE_APP_ID} messageOnly />

          <sg-error-page
            code={500}
            action-button-label="Back to home"
            action-button-link="/"
            contact-us="help-center"
            fullscreen={true}
            description-label={error.message}
            title-label="SGM Design Lab - Error"
          />
        </div>
      );
    }

    return children;
  }
}
